import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.initializeSelect2()
  }

  disconnect() {
    // Cleanup Select2 instance
    $(this.selectTarget).select2('destroy')
  }

  initializeSelect2() {
    $(this.selectTarget).select2({
      width: '130px',
      minimumResultsForSearch: Infinity, // Hides the search box
      escapeMarkup: function(data) { return data; }, // Allow HTML
      formatResult: this.formatResult.bind(this),
      formatSelection: this.formatSelection.bind(this)
    }).on('change', (event) => {
      this.handlePriorityChange(event)
    })
  }

  // Custom formatters to render HTML in Select2
  formatResult(state) {
    if (!state.id) { return state.text; }
    return state.text;
  }

  formatSelection(state) {
    if (!state.id) { return state.text; }
    return state.text;
  }

  handlePriorityChange(event) {
    const priority = event.target.value
    const actionUrl = this.element.getAttribute('action')

    // Create a new XMLHttpRequest
    const xhr = new XMLHttpRequest()

    // Configure it: PATCH-request for the URL
    xhr.open('PATCH', actionUrl, true)

    // Set the request headers
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    const csrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content')
    xhr.setRequestHeader('X-CSRF-Token', csrfToken)

    // Define the callback for when the request completes
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const data = JSON.parse(xhr.responseText)
            if (data.success) {
              // Dispatch a custom event with the updated priority
              const event = new CustomEvent('priority:updated', {
                detail: { taskId: data.task_id, priority: data.priority }
              })
              document.dispatchEvent(event)
            } else {
              console.error('Failed to update priority')
              // Optionally reset to previous value
              if (data.original_priority) {
                $(this.selectTarget).select2('val', data.original_priority)
              }
            }
          } catch (e) {
            console.error('Error parsing response:', e)
          }
        } else {
          console.error('Failed to update priority. Status:', xhr.status)
        }
      }
    }

    // Handle network errors
    xhr.onerror = () => {
      console.error('Network error while updating priority')
    }

    // Prepare the data to send
    const payload = JSON.stringify({ task: { priority: priority } })

    // Send the request with the JSON payload
    xhr.send(payload)
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task-priority-update-controller.js